import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-dialog-okayCancel',
    template: require('./dialogOkayCancel.html')
})
export class DialogOkayCancelComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<DialogOkayCancelComponent>) public dialogRef: MatDialogRef<DialogOkayCancelComponent>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}
